import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getClosedMeldinger, setDriftsmeldingCookie } from './cookie';
import InfoEllerDriftsmelding from './info-eller-driftsmelding';
/**
 * Komponent for visning av melding, med mulighet for å lukke meldingen og lagre lukket status i cookie
 */
const InfoEllerDriftsmeldingWrapper = props => {
    const { melding, isVisibleOnFirstRender = true, ...rest } = props;
    const isClosable = melding.messageType === 'driftsmelding' || !!melding.isClosable;
    // Melding som ikke kan lukkes, er alltid synlig. For meldinger som kan lukkes, så er de enten synlige fra start (isVisibleOnFirstRender = true) på åpne sider,
    // eller skjult fra start (isVisibleOnFirstRender = false) på tjenestesidene.
    const [isVisible, setIsVisible] = useState(!isClosable ? true : isVisibleOnFirstRender);
    const handleClose = () => {
        setDriftsmeldingCookie(melding.id, melding.unixTimeStamp);
        setIsVisible(false);
    };
    useEffect(() => {
        // Dersom meldingen ikke kan lukkes, vil den allerede være synlig, og vi trenger ikke sjekke cookie
        if (!isClosable) {
            return;
        }
        const closed = getClosedMeldinger();
        const isClosed = closed[melding.id] && closed[melding.id] === melding.unixTimeStamp;
        // eslint-disable-next-line react-hooks/set-state-in-effect -- SSR i CMSet krever at vi leser fra cookie i useEffect, og da må vi sette state her
        setIsVisible(!isClosed);
    }, [melding.id, melding.unixTimeStamp, isClosable]);
    if (!isVisible) {
        return null;
    }
    return _jsx(InfoEllerDriftsmelding, { melding: melding, ...rest, onClose: handleClose, isClosable: isClosable });
};
export default InfoEllerDriftsmeldingWrapper;
